import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import LazyImage  from '../components/lazy-image';
import httpRequest from '../components/request-api'
import { Pagination } from '@material-ui/lab';
import moment from 'moment';

class News extends Component {
  constructor(props) {
    super(props);
    this.state= {
      news:[],
      popular:[],
      search:"",
      preload:false
    }
  }

  renderNews = async (page, search) => {
    this.setState({
      preload: true
    })
    await httpRequest.news(page, search).then(result => {
        this.setState({
          news : result.data.result.news,
          pages : result.data.result.pages,
          page: result.data.result.page,
          preload: false
        })
    }).catch(error => {
        console.log(error);
        this.setState({
          preload: false
        })
    })
  } 

  renderNewsPopular = async () => {
    await httpRequest.newsPopular().then(result => {
      this.setState({
        popular : result.data.result
      })
    }).catch(error => {
        console.log(error);
    })
  } 

  componentDidMount() {
    this.renderNews(1)
    this.renderNewsPopular()
  }

  render() {
    const handleClick = (id) => {
      this.props.history.push(`/news-detail/${id}/${localStorage.getItem("i18nextLng")}`)
    };

    const handleChange = (event) => {
      this.setState({
        search: event.target.value
      })
    };

    const submit = (e) => {
      this.renderNews(1, this.state.search)
    }

    const handleChangePage = (event, page) => {
      this.renderNews(page)
    };
    const { t } = this.props;
    const { news, pages, page, popular, preload } = this.state
    return (
    <div id="app">
  <section className="blog_area section-padding">
    <div className="container">
      <div className="row">
        <div className="col-lg-8 mb-5 mb-lg-0">
          { !preload ? 
          <div className="blog_left_sidebar">
            { news.length !== 0 ? <>
            { news.map((item, i)=>(
              <article className="blog_item" key={i}>
                <div className="blog_item_img">
                  <LazyImage
                  thumb={item.image_url}
                  main={item.image_url}
                  alt=""
                     height={570 / 1260}
                />
                  <a href="#" onClick={() => handleClick(item.id)} className="blog_item_date" style={{zIndex: "1", cursor:"pointer"}}>
                    <h3>{moment(item.publish_date).format('DD')}</h3>
                    <p>{moment(item.publish_date).format('MMM')}</p>
                  </a>
                </div>
                <div className="blog_details">
                  <a href="#" className="d-inline-block" onClick={() => handleClick(item.id)} style={{cursor:"pointer"}}>
                      <h2>{item.topic}</h2>
                  </a>
                      <p>{item.summary}</p>
                </div>
              </article>
            ))
            }</> :  <h6 className="p-5">Search not found!</h6>
          }
            <Pagination count={pages} page={page} size="large" onChange={handleChangePage} className="justify-content-center"/>
          </div> : 
            <div id="preloader-active">
              <div className="preloader d-flex align-items-center justify-content-center" style={{backgroundColor: "initial"}}>
                <div className="preloader-inner position-relative">
                  <div className="preloader-circle"></div>
                  <div className="preloader-img pere-text">
                    <img src="/assets/img/logo/TGALogo.png" alt=""/>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div className="col-lg-4">
          <div className="blog_right_sidebar">
            <aside className="single_sidebar_widget search_widget">
              <form action="#">
                <div className="form-group">
                  <div className="input-group mb-3">
                    <input type="text" className="form-control" placeholder={t('keyword')} onFocus={() => this.placeholder = ''} onBlur={() => this.placeholder = 'Search Keyword'} onChange={handleChange} />
                    <div className="input-group-append">
                      <button className="btns" type="button"><i className="ti-search"  onClick={submit}/></button>
                    </div>
                  </div>
                </div>
                <button className="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn" type="button" onClick={submit}>{t('search')}</button>
              </form>
            </aside>
            <aside className="single_sidebar_widget popular_post_widget">
              <h3 className="widget_title">{t('latestNews')}</h3>
              {
                popular.map((item, i)=>(
              <div className="media post_item" key={i} onClick={() => handleClick(item.id)}>
                <img src={`${item.image_url}/128`} alt="post" />
                <div className="media-body">
                  <a href="#">
                    <span style={{cursor:"pointer"}}>{item.topic}</span>
                  </a>
                  <p><small>{moment(item.publish_date).format('LL')}</small></p>
                </div>
              </div>
              ))}
            </aside>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

    );
  }
}

export default withNamespaces()(News);